module.exports = __webpack_public_path__ + "34d3a5d10e2dc5aa3fe6e9d3f51fc2d8.jpg";